import { useTranslation } from "react-i18next";
import { FlightTypeSelect } from "../../../../../types";
import React from "react";
interface FlightTypeInputProps {
  id: string;
  disabled: boolean;
  value: FlightTypeSelect;
  label: string;
  onSelect: (FlightTypeSelect) => void;
}

function FlightTypeSelectInputSFO({
  id,
  disabled,
  value,
  label,
  onSelect,
}: FlightTypeInputProps) {
  const { t } = useTranslation();  
  const onChange = (e) => {
    onSelect(e.target.value);  
  };

  return (
    <div className="field">
      <label className="label" htmlFor={id}>
        {label}
      </label>
      <div className="control">
        <div className="select is-fullwidth">
          <select id={id} value={value} onChange={onChange} disabled={disabled}>
            <option value="NON_STOP">
              {t("NON_STOP")}
            </option>
            <option value="CONNECTING">
              {t("CONNECTING")}
            </option>
            <option value="ALL">
              {t("ALL")}
            </option>
          </select>
        </div>
      </div>
    </div>
  );
}

export default FlightTypeSelectInputSFO;
